import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import Cookies from 'js-cookie'

const state = {
  user: {
    token: Cookies.get('token', { domain: process.env.DOMAIN }),
    products: []
  },
  loading: false,
  error: false
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/index.js